require('./OKBadge.scss');

const className = require('classnames');
const PropTypes = require('prop-types');
const React= require('react');

class OKBadge extends React.Component {
    render() {
        const { customClassName, name, target, tooltip, toUrl } = this.props;
        let badgeTooltip;
        let content;

        if (tooltip) {
            badgeTooltip = <div className="ok-badge__tooltip">{tooltip}</div>;
        }

        const classNameComponent = className('ok-badge', {
            [customClassName]: !!customClassName
        });

        const classNameBadge = className('ok-badge__badge', {
            'ok-badge__badge-as-link': !!toUrl
        });

        if (!!toUrl) {
            content = (<a className="ok-badge__badge-link-content" href={toUrl} target={target}>
                <span className="ok-badge__content">{name}</span>
            </a>);
        } else {
            content = (<span className="ok-badge__content">{name}</span>);
        }

        return (
            <div className={classNameComponent}>
                <div className={classNameBadge}>
                    {content}
                </div>
                {badgeTooltip}
            </div>
        );
    }
}

OKBadge.propTypes = {
    customClassName: PropTypes.string,
    name: PropTypes.string.isRequired,
    target: PropTypes.string,
    tooltip: PropTypes.object,
    toUrl: PropTypes.string
};

module.exports = OKBadge;
